/**
 * When notification is shown with NOTIFICATION_SHOW action, add ID to it & schedule a timeout to fire the
 * NOTIFICATION_HIDE action.
 */

import * as actionTypes from "../actions/actionTypes";

const notification = store => next => action => {
  if (action.type !== actionTypes.NOTIFICATION_SHOW) return next(action);

  const notifications = store.getState().notifications,
    notificationIds = Object.keys(notifications);

  // create id for this notification, so we can reference it in NOTIFICATION_HIDE action
  if (notificationIds.length > 0) {
    action.id = Math.max(...notificationIds.map(id => parseInt(id))) + 1;
  } else {
    action.id = 1;
  }

  const timeout = action.link ? 8000 : 5000;

  setTimeout(
    () =>
      next({
        type: actionTypes.NOTIFICATION_HIDE,
        id: action.id,
      }),
    timeout
  );

  next(action);
};

export default notification;
